import { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useQuery, paramsToObject } from './useQuery';
import { createQueryStringFromObject, removeFalsyProps } from 'modules/Utils';
import { clampFutureDate } from 'modules/Utils/Date';

export const useURLSearchQuery = () => {
  const navigate = useNavigate();
  const routerLocation = useLocation();

  const rawQueryParams = useQuery();
  const rawQueryObject = paramsToObject(rawQueryParams.toString());

  const endDate = useMemo(
    () => clampFutureDate(rawQueryObject.end_date),
    [rawQueryObject.end_date]
  );
  const queryObject = rawQueryObject.end_date
    ? { ...rawQueryObject, end_date: endDate }
    : rawQueryObject;

  const clampedParams = new URLSearchParams(rawQueryParams);
  if (rawQueryObject.end_date && endDate !== rawQueryObject.end_date) {
    clampedParams.set('end_date', endDate);
  }
  const queryParams = clampedParams.toString();

  const changeParams = (newParams) => {
    let queryString = createQueryStringFromObject(
      removeFalsyProps({
        ...queryObject,
        ...newParams,
      })
    );

    navigate({
      pathname: routerLocation.pathname,
      search: queryString,
    });
  };

  const deleteParam = (name = '') => {
    rawQueryParams.delete(name);
  };

  return { queryParams, queryObject, changeParams, deleteParam };
};
